<template>
  <div class="switcher" :class="[padding, background, { 'disabled': disabled }, { 'clickable': !disabled && !disableBody }, {'inline': inline}]" @click="clickBody">
    <Checkbox class="mr-2 mt-quarter" v-model="val" @input="toggle" :locked="locked" :disabled="disabled" v-if="type == 'checkbox'" :size="16" />
    <Toggler class="mt-quarter" :class="classToggler" v-model="val" @input="toggle" :locked="locked" :disabled="disabled" v-else />
    <div class="switcher-desc" @click.stop="clickBody" v-if="custom">
      <slot :hander="toggleManual"></slot>
    </div>
    <div class="switcher-desc" v-else>
      <p class="typo-paragraph14 typo-regular text-light-high mb-half noselect">
        <slot name="title"></slot>
      </p>
      <p class="typo-paragraph12 typo-regular text-light-low">
        <slot name="subtitle"></slot>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Switcher",
  props: {
    value: Boolean,
    locked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    custom: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "toggle"
    },
    padding: {
      type: String,
      default: "p-2"
    },
    classToggler: {
      type: String,
      default: "mr-2"
    },
    background: {
      type: String,
      default: "bg-light1"
    },
    disableBody: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      val: false
    };
  },
  computed: {},
  watch: {
    value(newV) {
      if (this.val != newV) this.val = newV;
    }
  },
  created() {
    this.val = this.value;
  },
  methods: {
    toggle() {
      this.$emit("input", this.val);
    },
    toggleManual() {
      if (this.disabled) {
        return;
      }
      this.val = !this.val;
      this.toggle();
    },
    clickBody(e) {
      if (this.disableBody) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      this.toggleManual();
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.mt-quarter {
  margin-top: 2px;
}
.switcher {
  display: flex;
  flex-direction: row;
  &.inline {
    display: inline-flex;
  }
  // &:not(.no-bg) {
  //   background: $light1;
  // }
  // &:not(.no-gutter) {
  //   padding: 16px;
  // }

  &-desc {
    flex: 1;
  }

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
.clickable {
  cursor: pointer;
}
</style>
